var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, memo } from 'react';
import useConfigStore from '../../../../stores/configStore';
import useProductStore from '../../../../stores/productStore';
import { UNIFIED_ACTION } from '../../../../utils/types';
import useErrorHandledMutation from '../../../../hooks/useErrorHandledMutation';
import LimitForm from '../LimitForm';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../../../api';
import useCustomerStore from '../../../../stores/customerStore';
import QuoteLoading from '../../../Tabs/Policy/QuoteLoading';
import useWidgetStore from '../../../../stores/widgetStore';
import useLatestQuote from '../../../../hooks/useLatestQuote';
import useErrorStore from '../../../../stores/errorStore';
import PolicyFormLoader from '../PolicyFormLoader';
import Form from '../../../common/Form';
import useLatestQuotesWithPolicies from '../../../../hooks/useLatestQuotesWithPolicies';
import { flattenNestedGroupQuestion, regroupAnswers, } from '../../../../utils/common';
var PolicyForm = memo(function (_a) {
    var _b;
    var setIsEditRequested = _a.setIsEditRequested, setRestartRequest = _a.setRestartRequest, setSelectedQuote = _a.setSelectedQuote, handleCreateKaynaHash = _a.handleCreateKaynaHash;
    var queryClient = useQueryClient();
    var _c = useWidgetStore(), applicationDataId = _c.applicationDataId, setFormActive = _c.setFormActive, setAnswers = _c.setAnswers, setApplicationDataId = _c.setApplicationDataId, setCreateQuoteSubmitted = _c.setCreateQuoteSubmitted, setActiveDraftQuote = _c.setActiveDraftQuote, activeDraftQuote = _c.activeDraftQuote, setCurrQuestionGroup = _c.setCurrQuestionGroup, unifiedState = _c.unifiedState, setUnifiedState = _c.setUnifiedState;
    var _d = useCustomerStore(), extCustomerID = _d.extCustomerID, customerId = _d.id, applicationFormData = _d.applicationFormData, extCustomer = __rest(_d, ["extCustomerID", "id", "applicationFormData"]);
    var _e = useProductStore(), productId = _e.id, productQuestionsSet = _e.productQuestionsSet, Underwriter = _e.Underwriter, setProduct = _e.setProduct, rest = __rest(_e, ["id", "productQuestionsSet", "Underwriter", "setProduct"]);
    var latestQuotesWithPolicies = useLatestQuotesWithPolicies(true);
    var latestQuote = useLatestQuote(applicationDataId);
    var _f = useState(), questions = _f[0], setQuestions = _f[1];
    var keys = useConfigStore().keys;
    var errorHandledMutation = useErrorHandledMutation().errorHandledMutation;
    var upsertDraft = useMutation(api.quote.upsertDraft, {
        onSuccess: function (response, _a) {
            var _b, _c, _d, _e, _f, _g, _h, _j;
            var finaliseQuote = _a.finaliseQuote, quoteId = _a.quoteId, unifiedAction = _a.unifiedAction, parentQuoteId = _a.parentQuoteId;
            var quoteStatus = ((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.quotePayload) === null || _c === void 0 ? void 0 : _c.status) ||
                ((_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.quote) === null || _e === void 0 ? void 0 : _e.status) ||
                ((_f = response.data) === null || _f === void 0 ? void 0 : _f.status);
            var newQuoteId = parentQuoteId || ((_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.quote) === null || _h === void 0 ? void 0 : _h.id) || ((_j = response.data) === null || _j === void 0 ? void 0 : _j.id);
            if (!quoteId) {
                setActiveDraftQuote(newQuoteId);
            }
            if (finaliseQuote && (unifiedAction || parentQuoteId)) {
                setUnifiedState(function (prev) {
                    var _a, _b;
                    if (((_a = prev.activeQuote) === null || _a === void 0 ? void 0 : _a.quote) &&
                        ((_b = prev.activeQuote) === null || _b === void 0 ? void 0 : _b.state) === 'Ack-inProgress') {
                        return {
                            activeQuote: __assign(__assign({}, prev.activeQuote), { state: 'Ack-submit' })
                        };
                    }
                    return {};
                });
            }
            if (quoteStatus !== 'draft' && finaliseQuote) {
                setCreateQuoteSubmitted(true);
                if (keys.widgetType == 'broker') {
                    handleCreateKaynaHash();
                }
                else {
                    setSelectedQuote(newQuoteId);
                    setIsEditRequested(false);
                    setCurrQuestionGroup(0);
                    setRestartRequest(false);
                    setAnswers(null);
                    // setProductId(null);
                    // const externalId = response?.data?.externalId || null;
                    // setApplicationDataId(null as any);
                    setQuestions(null);
                    setProduct({
                        id: null,
                        productName: null,
                        productParameters: null,
                        productQuestionsSet: null,
                        createdAt: null,
                        updatedAt: null,
                        UnderwriterId: null,
                        ProductTypeId: null,
                        Underwriter: null,
                        productBranding: null
                    });
                    setFormActive(false);
                    setActiveDraftQuote(null);
                }
            }
            if (keys.widgetType !== 'broker') {
                queryClient.invalidateQueries(['customer']);
            }
        }
    });
    var createQuote = useMutation(api.quote.create, {
        onSuccess: function (response) {
            var _a, _b, _c;
            setCreateQuoteSubmitted(true);
            if (keys.widgetType == 'broker') {
                handleCreateKaynaHash();
            }
            else {
                queryClient.invalidateQueries(['customer']);
                var newQuoteId = ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.quote) === null || _b === void 0 ? void 0 : _b.id) || ((_c = response.data) === null || _c === void 0 ? void 0 : _c.id);
                setSelectedQuote(newQuoteId);
                setRestartRequest(false);
                setAnswers(null);
                // setProductId(null);
                setApplicationDataId(null);
                setQuestions(null);
                setProduct({
                    id: null,
                    productName: null,
                    productParameters: null,
                    productQuestionsSet: null,
                    createdAt: null,
                    updatedAt: null,
                    UnderwriterId: null,
                    ProductTypeId: null,
                    Underwriter: null,
                    productBranding: null
                });
                setFormActive(false);
            }
        }
    });
    var upsertDraftQuoteMutation = function (items, quoteId, customerID, quoteExternalId, selectedProductId, finaliseQuote) {
        if (finaliseQuote === void 0) { finaliseQuote = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payloadItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payloadItems = items ? items : extCustomer.items;
                        if (unifiedState.productType) {
                            payloadItems['otherParams'] = __assign(__assign({}, (payloadItems['otherParams'] || {})), { productType: unifiedState.productType });
                        }
                        if (unifiedState.isRestart) {
                            payloadItems['otherParams'] = __assign(__assign({}, (payloadItems['otherParams'] || {})), { onlyFor: unifiedState.productType });
                        }
                        return [4 /*yield*/, errorHandledMutation(function () {
                                return upsertDraft.mutateAsync({
                                    customerID: customerID,
                                    productId: selectedProductId ? selectedProductId : productId,
                                    items: payloadItems,
                                    saasId: keys.platformId,
                                    externalID: extCustomerID,
                                    quoteExternalId: unifiedState.externalId || quoteExternalId,
                                    quoteId: unifiedState.activeQuoteId || quoteId,
                                    finaliseQuote: finaliseQuote,
                                    unifiedAction: unifiedState.action,
                                    parentQuoteId: unifiedState.parentQuoteId
                                });
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var latestQuestions = {};
        if (activeDraftQuote === null &&
            unifiedState.productType &&
            unifiedState.parentQuoteId &&
            unifiedState.parentQuoteId === (latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.id)) {
            return;
        }
        if (latestQuote &&
            (latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.partnerIdentifier) === 'brizaUnifiedHiscox' &&
            (latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.status) !== 'rejected') {
            setActiveDraftQuote(latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.id);
            if (((_a = latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.partnerData) === null || _a === void 0 ? void 0 : _a.quotes) &&
                unifiedState.action &&
                unifiedState.activeQuoteId &&
                [
                    UNIFIED_ACTION.SHOW_COVERAGE_QUESTIONS_TO_FE,
                    UNIFIED_ACTION.SHOW_ACK_QUESTIONS_TO_FE,
                ].includes(unifiedState.action)) {
                var ques = {};
                var activeQuote = latestQuotesWithPolicies.find(function (q) { return q.id === unifiedState.activeQuoteId; });
                if (activeQuote) {
                    var key = activeQuote.externalId;
                    if ((unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) ===
                        UNIFIED_ACTION.SHOW_COVERAGE_QUESTIONS_TO_FE) {
                        ques["".concat(key, " coverages")] =
                            (_e = (_d = (_c = (_b = activeQuote === null || activeQuote === void 0 ? void 0 : activeQuote.partnerData) === null || _b === void 0 ? void 0 : _b.quotes) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.coverageQuestions) === null || _e === void 0 ? void 0 : _e.coverages;
                    }
                    else if ((unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) === UNIFIED_ACTION.SHOW_ACK_QUESTIONS_TO_FE) {
                        ques["".concat(key, " acknowledgements")] =
                            (_j = (_h = (_g = (_f = activeQuote === null || activeQuote === void 0 ? void 0 : activeQuote.partnerData) === null || _f === void 0 ? void 0 : _f.quotes) === null || _g === void 0 ? void 0 : _g[key]) === null || _h === void 0 ? void 0 : _h.ackQuestions) === null || _j === void 0 ? void 0 : _j.acknowledgements;
                    }
                }
                latestQuestions = ques;
            }
            else if (Object.keys(((_k = latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.partnerData) === null || _k === void 0 ? void 0 : _k.questions) || {}).length) {
                var ques = ((_l = latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.partnerData) === null || _l === void 0 ? void 0 : _l.questions) || {};
                latestQuestions = ques;
            }
        }
        if (!(latestQuestions && Object.keys(latestQuestions).length)) {
            if (latestQuote &&
                (latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.cerityQuoteId) &&
                (latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.quoteQuestions)) {
                latestQuestions = JSON.parse("".concat(latestQuote.quoteQuestions));
            }
            else if (productQuestionsSet && JSON.parse(productQuestionsSet)) {
                latestQuestions = JSON.parse("".concat(productQuestionsSet));
            }
        }
        if (latestQuestions) {
            setQuestions(flattenNestedGroupQuestion(latestQuestions));
        }
    }, [productQuestionsSet, latestQuote, unifiedState]);
    var handleSubmit = function (allData, currQuestionGroup, isLast) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, upsertDraftQuoteMutation({
                        otherParams: { currQuestionGroup: currQuestionGroup },
                        requiredParams: regroupAnswers(questions, allData)
                    }, activeDraftQuote, customerId, applicationDataId, productId, isLast)];
                case 1:
                    _a.sent();
                    if (isLast)
                        queryClient.removeQueries({
                            predicate: function (query) {
                                return query.queryKey[0] === 'documents' &&
                                    query.queryKey.includes(latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.id);
                            }
                        });
                    return [2 /*return*/];
            }
        });
    }); };
    if (createQuote.isLoading) {
        return React.createElement(QuoteLoading, { showAnimated: true, justifyCenter: true });
    }
    if (((_b = queryClient.getQueryState(['customer'])) === null || _b === void 0 ? void 0 : _b.status) == 'loading') {
        return React.createElement(QuoteLoading, null);
    }
    return (React.createElement(React.Fragment, null, questions && applicationFormData && applicationDataId && (React.createElement(Form, { productQuestionSet: questions, formTopText: (Underwriter === null || Underwriter === void 0 ? void 0 : Underwriter.widgetFlow) === 'racetrac'
            ? 'Some fields are pre-filled for convenience. You are responsible for ensuring all answers are accurate to the best of your knowledge.'
            : (Underwriter === null || Underwriter === void 0 ? void 0 : Underwriter.widgetFlow) === 'briza_hiscox'
                ? '14-day Guarantee information - If you cancel your policy within the first 14 days, your policy will terminate back to the start date of your policy term. In Maryland, policies shall terminate on the date you actually cancel your policy.'
                : undefined, createDraftQuote: handleSubmit }))));
});
var PolicyFormSwitch = function (props) {
    var _a, _b;
    var _c = useState(true), productLoading = _c[0], setProductLoading = _c[1];
    var _d = useState(false), creatingQuote = _d[0], setCreatingQuote = _d[1];
    var queryClient = useQueryClient();
    var customer = queryClient.getQueryData(['customer']);
    var _e = useProductStore(), id = _e.id, setProduct = _e.setProduct;
    var _f = useWidgetStore(), applicationDataId = _f.applicationDataId, savedAnswers = _f.answers, unifiedState = _f.unifiedState;
    var applicationFormData = useCustomerStore().applicationFormData;
    var setError = useErrorStore().setError;
    var answers = __assign(__assign({}, (_a = applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[(unifiedState.parentExternalId || applicationDataId)]) === null || _a === void 0 ? void 0 : _a.applicationDetails), savedAnswers);
    var formVersion = ((_b = applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[(unifiedState.parentExternalId || applicationDataId)]) === null || _b === void 0 ? void 0 : _b.formVersion) || 'list';
    var createQuoteMutation = useMutation({
        mutationKey: ['quote', 'new'],
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setCreatingQuote(true);
                        return [4 /*yield*/, api.quote.create(__assign(__assign({}, data), { formVersion: 'map' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        onSuccess: function (data) {
            queryClient.invalidateQueries(['customer']);
        }
    });
    useEffect(function () {
        if (!id)
            return;
        var fetchProduct = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setProductLoading(true);
                        return [4 /*yield*/, api.product.get(id)];
                    case 1:
                        response = _a.sent();
                        setProduct(response.data.data);
                        setProductLoading(false);
                        setError({ error: null });
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        setError({
                            error: 'Oops! 😔 It seems product is not configured correctly. Please check your configuration.'
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchProduct();
    }, [id]);
    var submitHandler = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var answers, customerData, quote;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    answers = data === null || data === void 0 ? void 0 : data.answers;
                    customerData = (_a = customer === null || customer === void 0 ? void 0 : customer.data) === null || _a === void 0 ? void 0 : _a.data;
                    return [4 /*yield*/, createQuoteMutation.mutateAsync({
                            customerID: customerData.id,
                            externalID: customerData.externalId,
                            items: {
                                otherParams: {},
                                requiredParams: answers
                            },
                            productId: id,
                            saasId: customerData.SaasPlatformId,
                            quoteExternalId: unifiedState.parentExternalId || applicationDataId
                        })];
                case 1:
                    quote = _b.sent();
                    props.setSelectedQuote(quote.data.quote.id);
                    return [2 /*return*/];
            }
        });
    }); };
    if (creatingQuote) {
        return React.createElement(QuoteLoading, { showAnimated: true, justifyCenter: true });
    }
    if (productLoading) {
        return React.createElement(PolicyFormLoader, null);
    }
    if (formVersion === 'map') {
        return (React.createElement(LimitForm, { onSubmit: submitHandler, latestQuote: null, answers: answers, scrollElem: document.querySelector('#containerId') }));
    }
    else {
        return React.createElement(PolicyForm, __assign({}, props));
    }
};
export default PolicyFormSwitch;
